import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridRow,
  GridCell,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import addIdToData from "../../utilities/addIdToData";
import { extractFileNameAndExtension } from "../../utilities/extractFileNameAndExtension";
import Loader from "../Loader";

export default function RejectedMembersDataTable({
  TableData,
  TableColumns,
  tableName,
  height = 450,
}) {
  const DataWithId = addIdToData(TableData);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const baseURL = axiosInstance.defaults.baseURL;
  const [loading, setLoading] = useState(false);

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  // Added by khalid starts

  const handleViewDocument = async (row, documentType, documentFileName) => {
    debugger;
    try {
      setLoading(true);
      // Fetch the document with the correct headers and response type for Blob
      const response = await axiosInstance.get(
        `/RegistrationFiles/${documentType}/${documentFileName}`,
        { responseType: "blob" }
      );

      // Get the file type (MIME type) from the response
      const fileType = response.headers["content-type"];

      // Create a Blob URL for the fetched file
      const fileURL = URL.createObjectURL(response.data);

      // Handle different file types
      if (fileType.startsWith("image/")) {
        // Open image in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "application/pdf") {
        // Open PDF in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "text/plain") {
        // Handle text file and display its content
        const text = await response.data.text();
        const textWindow = window.open();
        textWindow.document.write(`<pre>${text}</pre>`);
      } else {
        // For other file types, you can download or display it accordingly
        window.open(fileURL, "_blank");
      }
    } catch (error) {
      console.error("Error viewing document:", error);
      alert("Failed to view document: " + error.message);
    } finally {
      // Set loading state to false after the document fetch attempt (success or failure)
      setLoading(false);
    }
  };

  // Added by khalid ends

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarFilterButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarDensitySelector
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        {/* <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                /> */}

        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <GridToolbarExport
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
      </GridToolbarContainer>
    );
  }

  const columns = TableColumns.map((col) => {
    if (col.field === "name") {
      return {
        ...col,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={`https://api.adorable.io/avatars/50/${params.value}.png`}
              style={{ marginRight: 8 }}
            />
            {params.value}
          </div>
        ),
      };
    }
    return col;
  });

  const rows = DataWithId.map((row) => ({
    ...row,
    id: row.id || row.advocateBarId,
  }));

  const renderExpandableContent = (row) => (
    <Collapse in={expandedRowId === row.id} timeout="auto" unmountOnExit>
      <Box margin={1}>
        <div className="p-3 bg-light">
          <h4>Details for {row.name}</h4>
          <div className="row mt-3">
            <div className="col-md-6">
              <p>
                <strong>Advocate Bar ID:</strong> {row.advocateBarId}
              </p>
              <p>
                <strong>Relative Name:</strong> {row.relationshipType} of{" "}
                {row.relativeName}
              </p>
              <p>
                <strong>Mobile No:</strong> {row.mobileNo}
              </p>
              <p>
                <strong>Date of Birth:</strong>{" "}
                {new Date(row.dateOfBirth).toLocaleDateString()}
              </p>
              <p>
                <strong>Email:</strong> {row.email}
              </p>
              <p>
                <strong>Permanent Address:</strong> {row.permanentAddress}
              </p>
              <p>
                <strong>Membership Acceptance Date:</strong>{" "}
                {new Date(row.acceptedDate).toLocaleDateString()}
              </p>
              <p>
                <strong>Blood Group:</strong> {row.bloodGroup}
              </p>

              <p>
                <strong>Mentor Advocate Bar ID:</strong>{" "}
                {row.mentorAdvocateBarId}
              </p>
              <p>
                <strong>Mentor Advocate Name:</strong> {row.mentorAdvocateName}
              </p>
              <p>
                <strong>Chamber No:</strong> {row.chamberNo}
              </p>
              <p>
                <strong>Mentor Joining Date:</strong>{" "}
                {new Date(row.mentorJoiningDate).toLocaleDateString()}
              </p>
            </div>
            <div className="col-md-6">
              {/* <p>
                <strong>Aadhar Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_aadhar_documnets/${extractFileNameAndExtension(
                    row.aadharDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>AIBE Certificate:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_aibe_certificate/${extractFileNameAndExtension(
                    row.aibEcertificate
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Affidavit :</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_affidavit_documnets/${extractFileNameAndExtension(
                    row.affidavitDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>High School Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_highschool_documnets/${extractFileNameAndExtension(
                    row.highSchoolDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Intermediate Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_intermediate_documnets/${extractFileNameAndExtension(
                    row.intermediateDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Graduation Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_graduation_documnets/${extractFileNameAndExtension(
                    row.graduationDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Post Graduation Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_post_graduation_documnets/${extractFileNameAndExtension(
                    row.postGraduationDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Doctorate Document:</strong>{" "}
                <a
                  href={`${baseURL}/RegistrationFiles/view_doctrate_documnets/${extractFileNameAndExtension(
                    row.doctorateDocument
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p> */}
              {/* COMMENT BY KHALID ENDS*/}

              <p>
                <strong>Aadhar Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_aadhar_documnets",
                      extractFileNameAndExtension(row.aadharDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>AIBE Certificate:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_aibe_certificate",
                      extractFileNameAndExtension(row.aibEcertificate)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Affidavit :</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_affidavit_documnets",
                      extractFileNameAndExtension(row.affidavitDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>High School Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_highschool_documnets",
                      extractFileNameAndExtension(row.highSchoolDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Intermediate Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_intermediate_documnets",
                      extractFileNameAndExtension(row.intermediateDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Graduation Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_graduation_documnets",
                      extractFileNameAndExtension(row.graduationDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Post Graduation Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_post_graduation_documnets",
                      extractFileNameAndExtension(row.postGraduationDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Doctorate Document:</strong>{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_doctrate_documnets",
                      extractFileNameAndExtension(row.doctorateDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              <p>
                <strong>Previous Department:</strong> {row.previousDepartment}
              </p>
              <p>
                <strong>Registration Date:</strong>{" "}
                {new Date(row.registrationDate).toLocaleDateString()}
              </p>
              <p>
                <strong>Retirement Year:</strong>{" "}
                {new Date(row.retirementYear).getFullYear()}
              </p>
              <p>
                <strong>Status:</strong> {row.status}
              </p>
            </div>
          </div>
          {/* <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="success" onClick={() => handleAccept(row.id)}>
                            Accept
                        </Button>
                        <Button variant="contained" color="error" onClick={() => handleReject(row.id)}>
                            Reject
                        </Button>
                    </Box>
                    <p>Additional details can be added here...</p> */}
        </div>
      </Box>
    </Collapse>
  );

  const handleAccept = (id) => {
    console.log("Accepted:", id);
    // Handle accept action here
  };

  const handleReject = (id) => {
    console.log("Rejected:", id);
    // Handle reject action here
  };

  return (
    <>
      {loading && <Loader />}
      <div className="row justify-content-center mb-4">
        <div className="col-xxl-9">
          <div className="mt-5" style={{ height: height }}>
            <h2 className="mb-3 text-center">{tableName}</h2>
            <DataGrid
              rows={rows}
              columns={[
                {
                  field: "expand",
                  headerName: "",
                  width: 50,
                  filterable: false,
                  sortable: false,
                  hideable: false,

                  renderCell: (params) => (
                    <IconButton onClick={() => handleRowClick(params.row.id)}>
                      {expandedRowId === params.row.id ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  ),
                },
                ...columns,
              ]}
              slots={{
                toolbar: CustomToolbar,
              }}
              components={{ Toolbar: CustomToolbar }}
              disableRowSelectionOnClick
              hideFooterPagination
              getRowId={(row) => row.id}
            />
            {rows.map((row) => (
              <div key={row.id}>
                {expandedRowId === row.id && (
                  <div style={{ gridColumn: "1 / -1" }}>
                    {renderExpandableContent(row)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
